/**
 * named-urls setup with all the URLs for app
 * allows path to be looked up via the name
 * vs using the path directly
 */

export default {
  welcome: "/",
  chooseDocument: "/choose-document",
  instructions: "/instructions",
  confirmPicture: "/confirm-picture",
  thankYou: "/thank-you",
  error: "/error",
};
